<template>
    <div class="about-panel">
        <h1>Copyright</h1>
        <p>
            This software is
            <a
                href="https://opensource.org/license/mit"
                target="_blank"
                >MIT licensed</a
            >, Copyright (c) 2025-{{ new Date().getFullYear() }}
            Thomas Wajs
        </p>
        <p>
            Portions of the materials are the copyrights and trademarks of Paradox Interactive AB,
            and are used with permission. All rights reserved. For more information please visit
            <a
                href="https://worldofdarkness.com"
                target="_blank"
                >worldofdarkness.com</a
            >.
        </p>
        <p>
            This game is not affiliated with Paradox Interactive AB, and is not official World of
            Darkness material
        </p>
        <p>
            <a
                href="https://www.paradoxinteractive.com/games/world-of-darkness/community/dark-pack-agreement"
                target="_blank"
            >
                <img
                    src="/assets/darkpackLogo.png"
                    alt="dark pack logo"
                />
            </a>
        </p>
    </div>
</template>
<script setup lang="ts"></script>
